import {POST} from "@/services/gateway";

const listBackupsOverview = (filter) => {
    return POST('backup/overview', filter)
}

export {
    listBackupsOverview
}
